/**
 * This module must be imported before all jquery plugins, which often depend on a global jQuery object, or window.jQuery
 */

import * as $ from 'jquery-migrate'; // include jquery with support for removed features (migrate requires, and re-exports jQuery)
import "@popperjs/core"
import 'promise-polyfill/src/polyfill';
import 'whatwg-fetch';

window.$ = window.jQuery = $;

/**
 * Polyfill CustomEvent for Internet Explorer
 *
 * (from https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent)
 */
(function () {

    if (typeof window.CustomEvent === "function") return false;

    function CustomEvent(event, params) {
        params = params || {bubbles: false, cancelable: false, detail: null};
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    window.CustomEvent = CustomEvent;
})();

/**
 * Polyfill Element.matches and Element.closest
 * (from https://developer.mozilla.org/en-US/docs/Web/API/Element/closest)
 */
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        var el = this;

        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}
